import PropTypes from 'prop-types'
import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import i18n from 'simple-react-i18n'
import ToastrAction from 'toastr/actions/ToastrAction'
import Input from '../../../../components/forms/Input'
import { Button, Dialog, DialogActions, DialogContent, Grid } from '@mui/material'
import { DefaultDialogTitle } from 'components/styled/Dialog'
import DtoQualitometerLight from 'quality/dto/DtoQualitometerLight'
import DtoHydrometricStation from 'hydrometry/dto/DtoHydrometricStation'
import PluviometerDto from 'pluviometry/dto/PluviometerDto'
import { ProductionUnitShape } from 'productionUnit/shapes/ProductionUnitShapes'
import DtoDistributionUnit from 'distributionUnit/dto/DtoDistributionUnit'
import ResourceDto from 'resource/dto/ResourceDto'

const DashboardAddStationDialog = ({
    open = false,
    closeDialog = () => { },
    stations = [],
    title = '',
    onValidate = () => { },
}) => {
    const [code, setCode] = useState()
    const [name, setName] = useState()

    const dispatch = useDispatch()

    const onSave = () => {
        if (code || name) {
            const alreadyExist = stations.map(s => s.code?.toLowerCase()).includes(code?.toLowerCase())
            if (alreadyExist) {
                dispatch(ToastrAction.info(i18n.bssCodeAlreadyExists))
            } else {
                onValidate({ code, name })
            }
        } else {
            dispatch(ToastrAction.info(i18n.newInstallationCodeNameMessage))
        }
    }

    return (
        <Dialog
            open={open}
            maxWidth='lg'
        >
            <DefaultDialogTitle
                title={title}
                onClose={closeDialog}
            />
            <DialogContent>
                <Grid container justifyContent='space-between' sx={{ padding: '1rem' }}>
                    <Grid size={4}>
                        <Input
                            title={i18n.code}
                            value={code}
                            onChange={setCode}
                            clearFunction
                            noSpace
                            obligatory
                        />
                    </Grid>
                    <Grid size={7.5}>
                        <Input
                            title={i18n.name}
                            value={name}
                            onChange={setName}
                            clearFunction
                        />
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Grid container justifyContent='flex-end' alignItems='flex-end'>
                    <Button
                        variant='contained'
                        onClick={onSave}
                        disabled={!code}
                    >
                        {i18n.save}
                    </Button>
                </Grid>
            </DialogActions>
        </Dialog>
    )
}

DashboardAddStationDialog.propTypes = {
    open: PropTypes.bool,
    closeDialog: PropTypes.func,
    stations: PropTypes.arrayOf(PropTypes.oneOfType([
        PropTypes.instanceOf(DtoQualitometerLight),
        PropTypes.instanceOf(DtoHydrometricStation),
        PropTypes.instanceOf(PluviometerDto),
        ProductionUnitShape,
        PropTypes.instanceOf(DtoDistributionUnit),
        PropTypes.instanceOf(ResourceDto),
    ])),
    title: PropTypes.string,
    onValidate: PropTypes.func,
}

export default DashboardAddStationDialog